import analysis from './zh-CN/analysis';
import app from './zh-CN/app';
import common from './zh-CN/common';
import component from './zh-CN/component';
import dashboard from './zh-CN/dashboard';
import data from './zh-CN/data';
import globalHeader from './zh-CN/globalHeader';
import landing from './zh-CN/landing';
import menu from './zh-CN/menu';
import org from './zh-CN/org';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import system from './zh-CN/system';
import user from './zh-CN/user';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...user,
  ...landing,
  ...menu,
  ...dashboard,
  ...app,
  ...data,
  ...analysis,
  ...org,
  ...system,
  ...common,
  ...globalHeader,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
};
